<template>
    <div
        class="initial-cell text-xs cell sticky left-0 px-2 py-1.5 flex items-center justify-start border-r-2 border-gray-200 dark:border-gray-600 whitespace-nowrap min-w-[16rem]"
        :class="[background]"
    >
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        background: {
            type: Array | Object | String,
            default: 'bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-800',
        },
    },
};
</script>
